import { memo } from "react";
import { useSelector } from "react-redux";
import { Handle, Position } from "reactflow";
import classNames from "classnames";

const CustomNodeHandle = ({ isTarget, isHiddenNode }) => {
  const { isVerticalCanvasDirection } = useSelector((state) => state?.designer?.settings);
  const position = isTarget
    ? isVerticalCanvasDirection
      ? Position.Top
      : Position.Left
    : isVerticalCanvasDirection
    ? Position.Bottom
    : Position.Right;
  const type = isTarget ? "target" : "source";

  const handleClass = classNames({
    hiddenTop: isVerticalCanvasDirection && isTarget && isHiddenNode,
    hiddenBottom: isVerticalCanvasDirection && !isTarget && isHiddenNode,
    hiddenLeft: !isVerticalCanvasDirection && isTarget && isHiddenNode,
    hiddenRight: !isVerticalCanvasDirection && !isTarget && isHiddenNode,
    "node-handle": true,
  });

  return <Handle className={handleClass} style={{ opacity: 1 }} position={position} type={type} />;
};

export default memo(CustomNodeHandle);
